export default __webpack_public_path__ + "static/media/13.e08190fa.png";